import { KeyValue, KeyValueDefault } from "@/main/models/common";
import { PackageTypeDomainRequest } from "@/main/models/request";

export enum PackageTypes {
	GET_PACKAGE = "@package/GET_PACKAGE",
	SAVE_PACKAGE = "@package/SAVE_PACKAGE",
	RESET_REDUCER_PACKAGE = "@package/RESET_REDUCER_PACKAGE",
}

export interface PackageState {
	readonly package: {
		data: KeyValueDefault[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetPackage {
	type: typeof PackageTypes.GET_PACKAGE;
	payload: {
		request: PackageTypeDomainRequest;
	};
}

export interface SavePackage {
	type: typeof PackageTypes.SAVE_PACKAGE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerPackage {
	type: typeof PackageTypes.RESET_REDUCER_PACKAGE;
}

export type PackageActionTypes = GetPackage | SavePackage | ResetReducerPackage;
